const VISUAL_STYLES = {
  majorca_legado: {
    textColor: "#000000",
    frameColor: "#B8860B",
    fillColor: "#FFFFFF",
  },
  dourado_quad: {
    textColor: "#000000",
    frameColor: "#B8860B",
    fillColor: "#FFFFFF",
  },
  dourado_black: {
    // Texto branco sobre fundo preto (SEM-TEXTO PRETO). Nunca usar ouro aqui:
    // ouro sobre branco/preto lega contraste insuficiente na tela e na leitura.
    textColor: "#FFFFFF",
    frameColor: "#000000",
    fillColor: "#000000",
  },
  // Texto preto sobre fundo branco — contraste WCAG; o ouro fica só na moldura.
  colorido_legado: {
    textColor: "#000000",
    frameColor: "#000000",
    fillColor: "#FFFFFF",
    logoFillColor: "#CC0000",
  },
  colorido_vazio: {
    textColor: "#000000",
    frameColor: "#000000",
    fillColor: "#FFFFFF",
    logoFillColor: "#CC0000",
  },
  majorca_authentic: {
    textColor: "#000000",
    frameColor: "#B8860B",
    fillColor: "#FFFFFF",
  },
  majorca_authentic_auto: {
    textColor: "#000000",
    frameColor: "#B8860B",
    fillColor: "#FFFFFF",
  },
  majorca_no_subgrades: {
    textColor: "#000000",
    frameColor: "#B8860B",
    fillColor: "#FFFFFF",
  },
  majorca_no_subgrades_auto: {
    textColor: "#000000",
    frameColor: "#B8860B",
    fillColor: "#FFFFFF",
  },
};

const getVisualStyle = (visual) =>
  VISUAL_STYLES[visual] || VISUAL_STYLES.majorca_legado;

export { VISUAL_STYLES, getVisualStyle
};
